import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { quarterParts } from './ratingApi'

export function useQuarterLabel(): (quarter: string) => string {
  const { t } = useTranslation()
  return useCallback(
    (quarter: string) => {
      const { year, quarter: number } = quarterParts(quarter)
      return t('hr.rating.quarterValue', { year: String(year), quarter: String(number) })
    },
    [t],
  )
}
